const withReducer = (initialState, handlers) => {
  return function reducer(state = initialState, action) {
    if (handlers[action.type]) {
      return handlers[action.type](state, action);
    }

    return state;
  };
};

export default withReducer;
